import React, { useEffect } from 'react';
import User from './User';
import { Link } from 'react-router-dom'

const UserIndex = ({ user, api }) => {

  useEffect(async () => {
    if (!user.jwt) return;
    api.getUsers();
  }, [user])

  if (user.accessLevel < 2) {
    return <div>Unauthorized</div>
  }

  if (!api.data.users) {
    return <div>Requesting user list...</div>
  }

  return <table className="table">
    <thead>
      <tr>
        <th scope="col">Username (EPPN)</th>
        <th scope="col">Group</th>
        <th scope="col">Federated?</th>
        <th scope="col">Admin?</th>
        <th scope="col">Approved?</th>
        <th scope="col">To approve</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      {api.data.users.map((u) => <User key={`user_${u.id}`} user={u} api={api} />)}
      <tr><td colSpan="6"><Link to="/user/new">Add new User</Link></td></tr>
    </tbody>
  </table>
}

export default UserIndex;